import {
  Box as Form,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { Container } from 'components/Layout/Container';
import { useAuth } from 'context/AuthUserContext';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTheme } from 'styled-components';

type Inputs = {
  email: string;
  failedAttempt?: string;
};

export const ResetPasswordForm = () => {
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors, isSubmitting },
  } = useForm<Inputs>();
  const { resetPassword } = useAuth();
  const { colors } = useTheme();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    const { email } = data;

    try {
      await resetPassword(email);
    } catch (error: any) {
      if (error?.code === 'auth/too-many-requests') {
        setError('failedAttempt', {
          message:
            'Access to this account has been temporarily disabled due to many failed login attempts. Please try again later.',
        });
      }
      console.log({ error });
    }
  };

  return (
    <Container display="flex" justifyContent="center" p="75px 0 150px 0">
      <Form
        maxW="500px"
        w="100%"
        as="form"
        onSubmit={handleSubmit(onSubmit)}
        borderRadius="4px"
        p="35px 50px"
        bg={colors.white}
      >
        <FormControl
          isInvalid={!!errors.email || !!errors.failedAttempt}
          mb="12px"
        >
          <FormLabel htmlFor="email">Email</FormLabel>
          <Input
            id="email"
            placeholder="name@example.com"
            type="email"
            {...register('email', {
              required: 'Name is required',
              onChange: () => clearErrors('failedAttempt'),
            })}
          />
          <FormErrorMessage>
            {errors.email && errors.email.message}
          </FormErrorMessage>
        </FormControl>
        <Button
          mt={3}
          isLoading={isSubmitting}
          type="submit"
          variant="primary"
          w="100%"
        >
          Reset Password
        </Button>
      </Form>
    </Container>
  );
};
